import flogo02 from "../../components/images/partnerLogo/flogo_02.svg";
import flogo03 from "../../components/images/partnerLogo/flogo_03.svg";
import flogo04 from "../../components/images/partnerLogo/flogo_04.svg";
import flogo05 from "../../components/images/partnerLogo/flogo_05.svg";
import flogo06 from "../../components/images/partnerLogo/flogo_06.svg";
import flogo07 from "../../components/images/partnerLogo/flogo_07.svg";
import flogo08 from "../../components/images/partnerLogo/flogo_08.svg";
import flogo09 from "../../components/images/partnerLogo/flogo_09.svg";
import flogo10 from "../../components/images/partnerLogo/flogo_10.svg";
import flogo11 from "../../components/images/partnerLogo/flogo_11.svg";
import flogo12 from "../../components/images/partnerLogo/flogo_12.svg";
import flogo13 from "../../components/images/partnerLogo/flogo_13.svg";
import flogo14 from "../../components/images/partnerLogo/flogo_14.svg";
import flogo15 from "../../components/images/partnerLogo/flogo_15.svg";
import flogo16 from "../../components/images/partnerLogo/flogo_16.svg";
import dhawaPhuket from "../../components/images/partnerLogo/dhawa-phuket.svg";
import skypark from "../../components/images/partnerLogo/skypark.png";

export const parterLogo = [
  {
    logoImg: flogo02,
    link: "http://www.angsanaresidences.com",
    name: "ANGSANA RESIDENCES",
    property: true,
    showLogo: true,
  },
  // {
  //   logoImg: flogo03,
  //   link: "http://www.angsanatelukbahang.com/",
  //   name: "ANGSANA PENANG",
  //   property: true,
  //   showLogo: true,
  // },
  {
    logoImg: flogo04,
    link: "http://www.banyantreeresidences.com/en",
    name: "BANYAN TREE RESIDENCES",
    property: true,
    showLogo: true,
  },
  {
    logoImg: flogo05,
    link: "https://cassiaresidences.com/",
    name: "CASSIA RESIDENCES",
    property: true,
    showLogo: true,
  },
  {
    logoImg: dhawaPhuket,
    link: "http://www.dhawaresidences.com/",
    name: "DHAWA RESIDENCES",
    property: true,
    showLogo: true,
  },
  {
    logoImg: flogo06,
    link: "http://www.lagunalangco.com/",
    name: "LAGUNA LĂNG CÔ",
    property: true,
    showLogo: true,
  },
  //  {
  //    logoImg: flogo07,
  //    link: "http://www.lagunalifestylehub.com/",
  //    name: "LAGUNA LIFESTYLE HUB",
  //    property: true,
  //    showLogo: true,
  //  },
  {
    logoImg: skypark,
    link: "https://www.lagunaproperty.com/en/projects/phuket/skypark",
    name: "SKY PARK",
    property: true,
    showLogo: true,
  },
  {
    logoImg: flogo08,
    link: "http://sanctuaryclub.com/",
    name: "The Santuary Club",
    property: true,
    showLogo: true,
  },
  {
    logoImg: flogo09,
    link: "http://www.banyantree.com/",
    name: "BANYAN TREE",
    property: false,
    showLogo: true,
    row: 2,
  },
  {
    logoImg: flogo10,
    link: "http://www.angsana.com/",
    name: "ANGSANA",
    property: false,
    showLogo: true,
    class: "angsana",
    row: 2,
  },
  {
    logoImg: flogo11,
    link: "http://www.banyantreespa.com/",
    name: "BANYAN TREE SPA",
    property: false,
    showLogo: true,
    row: 2,
  },
  {
    logoImg: flogo12,
    link: "http://www.angsanaspa.com/",
    name: "ANGSANA SPA",
    property: false,
    showLogo: true,
    class: "angsana",
    row: 2,
  },
  {
    logoImg: flogo13,
    link: "https://essentials.banyantree.com/",
    name: "BANYAN TREE GALLERY",
    property: false,
    showLogo: true,
    row: 2,
  },
  {
    logoImg: flogo14,
    link: "http://www.cassia.com/",
    name: "CASSIA",
    property: false,
    showLogo: true,
    row: 2,
  },
  {
    logoImg: flogo15,
    link: "http://www.dhawa.com/",
    name: "DHAWA",
    property: false,
    showLogo: true,
    row: 2,
  },
  {
    logoImg: flogo16,
    link: "http://www.lagunaphuket.com/",
    name: "LAGUNA PHUKET",
    property: false,
    showLogo: true,
    row: 2,
  },
];



// WEBPACK FOOTER //
// ./src/data/Common/parterLogo.js